import { useNavigate } from "react-router-dom";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DoneIcon from "@mui/icons-material/Done";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import "./viewContract.scss";
import HandshakeIcon from '@mui/icons-material/Handshake';
export default function ViewSPContract() {
    const navigate = useNavigate();

    return (
        <div className="view_contract_page">
            {/* Header */}
            <div className="top_bar">
                <div className="title_block">
                    <h1>Service Provider Agreement</h1>
                    <div className="sub_title">
                        This Service Provider Agreement ("Agreement") is entered into between:
                    </div>
                </div>

                <div className="actions">
                    <button>
                        <DownloadIcon /> Download PDF
                    </button>
                    <button>
                        <PrintIcon /> Print
                    </button>
                 
                </div>
            </div>

            {/* Parties Section */}
            <div className="contract_top_section">
                <div className="party_card">
                    <h2>Bouteek Platform FZ-LLC</h2>
                    <p>Level 12, Business Bay Tower</p>
                    <p>Sheikh Zayed Road, Dubai, UAE</p>
                    <p>support@bouteek.com</p>
                </div>

                <div className="handshake_icon_box">
                    <HandshakeIcon />
                </div>

                <div className="party_card">
                    <h2>ABC Lifestyle Store</h2>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <p>Service Provider ID: SP-025</p>
                            <p>sp@example.com</p>
                            <p>+971 50 987 6543</p>
                        </div>
                        <ul className="meta_list">
                            <li>Trade License No: XXXXXX789</li>
                            <li>License Type: Professional</li>
                            <li>License Category: Retail Trade</li>
                            <li>Economic License: Mainland</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Selectors Bar */}
            <div className="meta_selectors">
                <div className="selector">
                    <img src="https://flagcdn.com/w20/ae.png" alt="UAE" /> United Arab Emirates - English
                </div>
                <div className="selector">
                    <img src="https://flagcdn.com/w20/ae.png" alt="UAE" /> United Arab Emirates - English
                </div>
                <div className="v_info">
                    <div className="badge">Version: v1.2</div>
                    <div className="badge status">Status: Accepted</div>
                </div>
            </div>

            {/* Main Layout */}
            <div className="main_layout">
                <div className="agreement_container">
                    <h2>Service Provider Agreement</h2>

                    <p className="intro_text">
                        This Service Provider Agreement ("Agreement") is entered into between <b>Bouteek Platform FZ-LLC</b> ("Bouteek", "Platform") and the <b>Service Provider</b> listed below. This Agreement governs the terms under which the Service Provider,
                    </p>

                    <p className="intro_text">
                        By entering into this Agreement, the Service Provider acknowledges and all information provided is accurate and legally valid national, and international laws, regulations, and industry standards relevant to.
                    </p>

                    <div className="notice_box">
                        The Service Provider hereby confirms that they shall strictly abide by all rules, operational guidelines, and regulatory requirements established by the Bouteek Platform without prior notice.
                    </div>

                    <div className="accordion_section">
                        <Accordion defaultExpanded className="MuiAccordion-root">
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <div className="MuiAccordionSummary-content">
                                    <span className="num">1</span> Scope of Services
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p className="details_p">
                                    This Service Provider Agreement ("Agreement") is entered into between Bouteek Platform FZ-LLC
                                </p>
                                <div className="audit_info">
                                    <div className="audit_item">
                                        <CheckCircleOutlineIcon /> IP Address: 192.168.1.15
                                    </div>
                                    <div className="audit_item">
                                        <CheckCircleOutlineIcon /> Accepted On: 2024-01-12 15:34 GST
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>

                    <div className="acceptance_area">
                        <h4>Acceptance & Confirmation</h4>
                        <p className="abc_text">ABC Lifestyle Store digitally accepted this Agreement on:</p>
                        <div className="check_list">
                            <div className="check_row">
                                <span className="icon_box"><DoneIcon /></span> Check box confirmation during store onboarding
                            </div>
                            <div className="check_row">
                                <span className="icon_box"><DoneIcon /></span> Continued use of the platform services
                            </div>
                        </div>
                    </div>

                    <div className="signature_section">
                        <div className="party_bottom">
                            <p>Bouteek Platform FZ-LLC</p>
                            <div className="sign_line"></div>
                            <span>Authorized Signatory</span>
                        </div>
                        <div className="party_bottom">
                            <p>ABC Lifestyle Store</p>
                            <div className="sign_line"></div>
                            <span>Service Provider Representative</span>
                        </div>
                    </div>
                </div>

                <div className="sidebar_layout">
                    <div className="status_card">
                        <div className="top_v">
                            <span>Version: v1.2</span>
                        
                        </div>

                        <div className="status_item accepted">
                            <label>Status</label>
                            <span>Accepted</span>
                        </div>
                        <div className="status_item">
                            <label>Signed On</label>
                            <span>12 Jan 2024</span>
                        </div>
                        <div className="status_item">
                            <label>Expires</label>
                            <span>12 Jan 2025</span>
                        </div>
                    </div>

                    <div className="bottom_status_bar">
                        <span className="v">Version: v1.2</span>
                        <span className="s">Status: Accepted</span>
                     
                    </div>
                </div>
            </div>
        </div>
    );
}
